/**
 *
 * BusinessEnquiry Routes
 *
 * Please note: routes need to be added in main routes file at src/modules/routes.js
 * or src/{mobileApp/webApp}/routes.js depending on current file location
 */

import { lazyBusinessEnquiryPage } from './lazyBusinessEnquiry';

// routes declaration
export const businessEnquiryRoutes = [
  {
    component: lazyBusinessEnquiryPage,
    path: '/customer-assist/lead-management',
    title: 'Lead management',
    isPartner: false,
    needsAuth: true,
  },
];
